import type { FormDialogModel } from './hooks/useFormDialog';
import { BasicInfoTab } from './BasicInfoTab';

export const FormHeader = (dialog: FormDialogModel) => (
  <BasicInfoTab formMode={dialog.formMode} formState={dialog.formState} initialData={dialog.initialData} />
);
